<div class="modal-header modal-block-primary">
  <button type="button" class="close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Close</span>
  </button>
  <h4 class="modal-title">Enter Payment Details</h4>
  <h5 class="modal-title" style="color: red">{{ getModelErrors().join('\n') }}</h5>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-offset-2 col-md-8">
      <div class="paymentHeader">
        <span class="payTo"
          >Payable to <span class="displayName">{{ model.payeeName }}</span></span
        >
        <span class="payTo"
          >Total Payment:
          <span
            class="payment"
            [ngClass]="{ negative: model.totalPayment < 0, positive: model.totalPayment > 0 }"
            >{{ model.totalPayment | currency }}</span
          ></span
        >
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-offset-2 col-md-2"><label for="paymentDate">Payment Date:</label></div>
    <div class="col-md-6">
      <app-datetime
        id="paymentDate"
        [(ngModel)]="model.paymentDate"
        [options]="this.util.getDefaultDateOptions(false)"
      ></app-datetime>
    </div>
  </div>
  <div class="row">
    <div class="col-md-offset-2 col-md-2"><label>Type:</label></div>
    <div class="col-md-6">
      <label
        ><input
          name="paymentType"
          type="radio"
          [value]="PaymentType.CHK"
          [(ngModel)]="model.paymentType"
          [disabled]="model.totalPayment === 0"
        />
        Check</label
      >&nbsp;&nbsp;&nbsp;
      <label
        ><input
          name="paymentType"
          type="radio"
          [value]="PaymentType.EFT"
          [(ngModel)]="model.paymentType"
          [disabled]="model.totalPayment === 0"
        />
        Electronic Funds Transfer</label
      >
      <label
        ><input
          name="paymentType"
          type="radio"
          [value]="PaymentType.INFO"
          [(ngModel)]="model.paymentType"
          [disabled]="model.totalPayment !== 0"
        />
        Informational Only</label
      >
    </div>
  </div>
  <div class="row">
    <div class="col-md-offset-2 col-md-2"><label for="paymentMemo">Memo:</label></div>
    <div class="col-md-6">
      <input
        class="form-control"
        id="paymentMemo"
        type="text"
        [(ngModel)]="model.memo"
        maxlength="50"
      />
    </div>
  </div>
  <div class="row">
    <div class="col-md-offset-2 col-md-2"><label for="payerName">CHI Identifier:</label></div>
    <div class="col-md-6">
      <input class="form-control" id="payerName" type="text" [(ngModel)]="model.payerName" />
    </div>
  </div>

  <div class="row" [hidden]="model.paymentType !== PaymentType.EFT">
    <div class="col-xs-6">
      <div class="panel panel-default paymentPanel">
        <div class="row">
          <div class="col-md-12"><h4>Sender Information</h4></div>
          <div class="col-md-12">
            <h4>{{ model.payerName }}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"><label for="payerRoutingNumber">CHI Routing #:</label></div>
          <div class="col-md-6">
            <input
              class="form-control"
              id="payerRoutingNumber"
              type="number"
              [(ngModel)]="model.payerRoutingNumber"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"><label for="payerAccountNumber">CHI Account #:</label></div>
          <div class="col-md-6">
            <input
              class="form-control"
              id="payerAccountNumber"
              type="text"
              [(ngModel)]="model.payerAccountNumber"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-6">
      <div class="panel panel-default paymentPanel">
        <div class="row">
          <div class="col-md-12"><h4>Receiver Information</h4></div>
          <div class="col-md-12">
            <h4>{{ model.payeeName }}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"><label for="payeeRoutingNumber">Receiver Routing #:</label></div>
          <div class="col-md-6">
            <input
              class="form-control"
              id="payeeRoutingNumber"
              type="number"
              [(ngModel)]="model.payeeRoutingNumber"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"><label for="payeeAccountNumber">Receiver Account #:</label></div>
          <div class="col-md-6">
            <input
              class="form-control"
              id="payeeAccountNumber"
              type="text"
              [(ngModel)]="model.payeeAccountNumber"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    data-dismiss="modal"
    [disabled]="!modelStateIsValid()"
    (click)="okClick()"
  >
    Generate Provider Remittance
  </button>
  <button type="button" class="btn btn-default" data-dismiss="modal" (click)="cancelClick()">
    Cancel
  </button>
</div>
